import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  SharedDataService,
  PS_PAFX_DR_Result,
  PS_PAFX_Indicateur_Nb_Cdes_XRP_Result,
  PafxFinancesNbCmdsFilters
} from 'ngx-paf-common';

import {
  Observable,
  of,
  Subscription
} from 'rxjs';

import moment from 'moment';

import {
  ComboBoxComponent,
  MultiSelectComponent
} from '@progress/kendo-angular-dropdowns';

import {
  FinancesService
} from 'localServices/finances.service';

import {
  ExcelExportComponent,
  WorkbookSheetColumn,
  WorkbookSheetRow
} from '@progress/kendo-angular-excel-export';

import {
  DataStateChangeEvent,
  GridComponent
} from '@progress/kendo-angular-grid';

import {
  CompositeFilterDescriptor,
  DataResult,
  filterBy,
  State,
  process,
} from '@progress/kendo-data-query';

import { tap } from 'rxjs/operators';



@Component({
  selector: 'finances-detail-cmds',
  templateUrl: './finances-detail-cmds.component.html',
  styleUrls: ['./finances-detail-cmds.component.scss']
})

export class FinancesDetailCmdsComponent implements OnInit, OnDestroy {

  profilChangeSub: Subscription = null;
  datas?: PS_PAFX_Indicateur_Nb_Cdes_XRP_Result[];
  filteredDatas: PS_PAFX_Indicateur_Nb_Cdes_XRP_Result[] = [];
  datasLoaded: boolean = false;
  gridData?: DataResult;
  @ViewChild("cboPoles") public cboPoles: MultiSelectComponent;
  @ViewChild("cboRegs") public cboRegs: MultiSelectComponent;
  @ViewChild("cboEtbMulti") public cboEtbMulti: MultiSelectComponent;
  @ViewChild("cboEtbSimple") public cboEtbSimple: ComboBoxComponent;
  @ViewChild('excelexport') excelExportComponent: ExcelExportComponent;
  @ViewChild('financesCmdsGrid') grid: GridComponent;
  excelExportFileName: string = 'Finance-' + moment().format('YYYYMMDD-HHmm') + '.xlsx';
  public state: State = {};
  filters: PafxFinancesNbCmdsFilters = new PafxFinancesNbCmdsFilters();
  visibleFilters: boolean = true;
  lstEtablissements: PS_PAFX_DR_Result[] = [];
  public gridPageableSettings: any = {
    pageSizes: [10, 20, 50, 100],
    position: 'top'
  };
  gridTopDetailParEtb:boolean=false;




  constructor(
    public sharedDataSvc: SharedDataService,
    private financesSvc: FinancesService) { }


  ngOnInit(): void {
    if (this.sharedDataSvc.profilLoaded) {
      this.checkAccessTakapa();
    }
    this.profilChangeSub = this.sharedDataSvc.loggedProfilChange.subscribe(p => {
      this.checkAccessTakapa();
    });
    this.financesSvc.Drs()
      .subscribe(results => {
        this.lstEtablissements = results;
        this.reinitAll();
      });
  }

  ngOnDestroy(): void {
    this.profilChangeSub.unsubscribe();
  }

  get gridHeight(): number {
    return this.visibleFilters ? 500 : 670;
  }


  //Axe 1
  get lstPoles(): PS_PAFX_DR_Result[] {
    return this.lstEtablissements.filter(item => !!item.PolCod).distinctValues('PolCod');
  }

  //Axe 2
  get lstRegs(): PS_PAFX_DR_Result[] {
    return this.lstEtablissements
      .filter(r => (!this.filters.PolCod) || r.PolCod == this.filters.PolCod)
      .distinctValues('RegCod');
  };

  get lstEtbs(): PS_PAFX_DR_Result[] {
    return this.lstEtablissements
      .filter(r => (!this.filters.PolCod) || r.PolCod == this.filters.PolCod)
      .filter(r => (!this.filters.RegCod) || r.RegCod == this.filters.RegCod)
      .distinctValues('EtbCod');
  }

  get TopPerimetre(): boolean {
    return this.filters.TopPerimetre;
  }
  set TopPerimetre(value: boolean) {
    if (this.filters.TopPerimetre != value) {
      if (value) {
        this.selectAll();
      }
      this.filters.TopPerimetre = value;
    }
  }


  selectAll() {
    this.filters.PolCod = '';
    this.filters.RegCod = '';
    this.filters.EtbCods = [];
  }

  checkAccessTakapa(): void {
    if (!this.sharedDataSvc.checkProfilAccessPafSettings('TAKAPA')) {
      this.sharedDataSvc.alert('Votre profil ne vous autorise pas à accéder à cet écran'
        , () => {
          if (this.profilChangeSub != null) this.profilChangeSub.unsubscribe();
          this.sharedDataSvc.redirectToDefaultScreen();
        });
    }
  }

  displayEtb(etbCod:String): string {
    let item:PS_PAFX_DR_Result = this.lstEtablissements.find(e=>e.EtbCod==etbCod);
    if (!item) return '';
    return item.SocCod + ' ' + item.EtbLib;
  }

  toggleDisplayFilters(): void {
    this.visibleFilters = !this.visibleFilters;
  }

  public highlightSearch(display: string, search: string): string {
    if (!display || !search) return display;
    let startIndex: number = display.toLowerCase().removeAccents().indexOf(search.toLowerCase().removeAccents());
    if (startIndex < 0) return display;
    let endIndex = startIndex + search.length;
    return [
      display.slice(0, startIndex),
      '<mark>',
      display.slice(startIndex, endIndex),
      '</mark>',
      display.slice(endIndex)
    ].join('');
  }


  public reinitAll() {
    this.reinit();
    this.resetFilters();
  }

  public reinit() {
    this.filters = new PafxFinancesNbCmdsFilters();
    this.filters.MmDe = '01';
    this.filters.AaaaDe = moment().format('YYYY');
    this.filters.MmA = moment().format('MM')
    this.filters.AaaaA = moment().format('YYYY');
    this.filters.TopDetailParEtb = false;
    this.selectAll();
  }

  get excelDatas(): Observable<any[]> {
    if ((this.datas || []).length > 0 || this.datasLoaded) {
      return of(this.datas);
    } else {
      return this.getDatas();
    }
  }

  public search(): void {
    this.sharedDataSvc.WindowLock();
    this.gridTopDetailParEtb = this.filters.TopDetailParEtb;
    this.state.group = this.filters.TopDetailParEtb ? [{ field: 'displayEtb' }] : undefined;
    this.getDatas()
      .subscribe(res => {
        this.sharedDataSvc.WindowUnlock();
      },
        (response: any) => {
          this.sharedDataSvc.WindowUnlock();
          this.sharedDataSvc.alert(response.error.Message || response.error);
        });
  }

  getDatas(): Observable<PS_PAFX_Indicateur_Nb_Cdes_XRP_Result[]> {
    return this.financesSvc.SearchNbCommandes(this.filters)
      .pipe(tap((results: PS_PAFX_Indicateur_Nb_Cdes_XRP_Result[]) => {
        this.datas = results;
        this.datas.forEach(item=>(<any>item).displayEtb=this.displayEtb(item.EtbCod));
        this.state.skip = 0;
        this.datasLoaded = true;
        this.bindDatasToGrid();
      }));
  }

  clear(): void {
    this.datas = [];
    this.gridData.data = [];
    this.gridData.total = 0;
  }

  public resetFilters(): void {
    this.state = {
      skip: 0,
      take: 50,
    };
    this.datas = [];
    this.bindDatasToGrid();
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.state.filter = filter;
    this.bindDatasToGrid();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.bindDatasToGrid();
  }

  public bindDatasToGrid() {
    this.filteredDatas = filterBy(this.datas, this.state.filter);
    this.gridData = process(this.datas, this.state);
  }

  public exportExcel() {
    this.sharedDataSvc.WindowLock();
    this.excelDatas.subscribe(xDatas => {
      let component: ExcelExportComponent = this.excelExportComponent;
      component.data = xDatas;
      const options = component.workbookOptions();
      let header: WorkbookSheetRow = options.sheets[0].rows.find(r => r.type == 'header');
      if (header) {
        const cols = options.sheets[0].columns;
        cols.forEach((col: WorkbookSheetColumn, i: number) => {
          col.autoWidth = true;
        });
      }
      component.save(options);
      // Vu que l'export répond lentement, on retarde la fin du sablier d'1s par millier d'enregistrement
      setTimeout(() => {
        this.sharedDataSvc.WindowUnlock();
      }, xDatas.length);
    });
  }

  poleSearchMask: string;
  onPolesFilterChanged(filter: string): void {
    this.poleSearchMask = filter;
  }
  regSearchMask: string;
  onRegsFilterChanged(filter: string): void {
    this.regSearchMask = filter;
  }
  etbSearchMask: string;
  onEtbsFilterChanged(filter: string): void {
    this.etbSearchMask = filter;
  }


  get selectedEtbs(): PS_PAFX_DR_Result[] {
    return this.lstEtablissements.filter(item => this.filters.EtbCods.indexOf(item.EtbCod) >= 0);
  }


  public onAxeChanged(value: string, filterName: string) {
    switch (filterName) {
      case 'PolCod':
        if (value) this.filters.RegCod = this.lstEtablissements.find(item => item.PolCod == value && item.RegCod == this.filters.RegCod)?.RegCod;
        this.onAxeChanged(this.filters.RegCod, 'RegCod');
        break;
      case 'RegCod':
        this.filters.EtbCods = this.selectedEtbs
          .filter(item => !this.filters.PolCod || item.PolCod == this.filters.PolCod)
          .filter(item => !this.filters.RegCod || item.RegCod == this.filters.RegCod)
          .map(item => item.EtbCod)
          .distinct();
        break;
    }
  }

}
